import { List, Map } from 'immutable'
import { any, async, IOWidget, nothing, Updater, Widget } from 'widgets-for-react'
import { PublicSiteState } from '../../../../../root/state'
import { DrupalBlock_To_WidgetBlock } from '../../drupal/drupal_to_cms.mod'
import { GetDrupalBlockImagesLoaders } from '../../drupal/rendering/image_utils.mod'
import { CustomBlock_To_Widget } from '../../public_site/application.mod'
import { CustomBlockData } from '../../public_site/blocks/custom_blocks/types.mod'
import { notfound_page } from '../../public_site/templates/error_page.mod'
import { loaderFull } from '../../public_site/templates/loader.mod'
import { BlockData } from '../blocks/types.gen'
import { TemplateState } from './types.gen'

export const PageTemplateComponent_AUX =
  (
    async_key: string,
    pageDisplay: IOWidget<TemplateState, Updater<TemplateState>>,
    Display: (
      placeholder: Widget<Updater<TemplateState>>
    ) => (state: PublicSiteState) => Widget<Updater<TemplateState>>,
    public_state: PublicSiteState
  ): IOWidget<TemplateState, Updater<TemplateState>> =>
  (s0) =>
    any([
      async(s0.page, undefined, {
        loading: (_) => loaderFull,
        connectionError: notfound_page(public_state),
        otherError: notfound_page(public_state),
        key: async_key
      }).map<Updater<TemplateState>>((updatePage) => (s1) => {
        let newPage = updatePage(s1.page)
        let images = s1.images
        let blocks = s1.blocks
        if (newPage.kind === 'loaded') {
          newPage.value.blocks.forEach((b) => {
            let images_to_load = GetDrupalBlockImagesLoaders(b)
            images_to_load.forEach((i) => {
              if (!images.has(i[0])) {
                images = images.set(i[0], i[1])
              }
            })
          })

          let extra_data = newPage.value.extra_data

          blocks = Map<number, BlockData | CustomBlockData>(
            List(newPage.value.blocks).flatMap((b, i: number) => {
              let res = DrupalBlock_To_WidgetBlock(b, i, extra_data, CustomBlock_To_Widget)
              return res.kind === 'l' ? [] : [[i, res.v]]
            })
          )
        }
        return { ...s1, blocks: blocks, images: images, page: newPage }
      }),
      s0.page.kind == 'loaded' ? Display(pageDisplay(s0))(public_state) : nothing(),

      ...s0.images
        .map((e, i) =>
          async(e).map<Updater<TemplateState>>((a) => (s) => ({ ...s, images: s.images.set(i, a(s.images.get(i))) }))
        )
        .valueSeq()
        .toArray()
    ])
